import type { HTMLProps } from 'react';

import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Footer } from 'src/apps/footer/Footer';
import { Header } from 'src/apps/header/Header';
import { Sidebar } from 'src/apps/header/Sidebar';
import { RouteLoadingSpinner, SomethingWentWrong } from 'src/components';
import { cn } from 'src/utils/classNamesHelper';

function Wrapper({ children, className, ...props }: HTMLProps<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex size-full min-h-screen grow animate-fade-in flex-col items-center justify-between bg-paper-2',
        className
      )}
      {...props}
    >
      <div className="w-full">
        <div className="flex">
          <Sidebar />
          <div className="relative min-h-screen w-full flex-1 overflow-hidden">
            <Header variant="full" />
            <div className="mt-64 flex min-h-[calc(100vh-200px)] grow flex-col lm:mt-0">
              {children}
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_auth/_layout')({
  wrapInSuspense: true,
  errorComponent: ({ error, reset, info }) => (
    <Wrapper>
      <SomethingWentWrong error={error} reset={reset} info={info} />
    </Wrapper>
  ),
  pendingComponent: () => (
    <Wrapper>
      <RouteLoadingSpinner />
    </Wrapper>
  ),
  component: () => (
    <Wrapper>
      <Outlet />
    </Wrapper>
  ),
});
